import styled from 'styled-components';

export const EmptyItemSC = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid transparent;
  background: #f8f9f8;
  overflow: hidden;

  .content {
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .text {
      margin-top: 5px;
      opacity: 0;
      text-align: center;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;

      /* identical to box height, or 171% */

      color: #181e34;
      mix-blend-mode: normal;
      transition: opacity 0.2s, visibility 0.2s;
      transition-delay: 0.05s;
    }

    svg {
      transform: scale(0);
      transition: transform 0.2s;
    }
  }

  .menu-open & {
    cursor: default;
  }

  &:hover:not(.menu-open &) {
    .content {
      .text {
        opacity: 0.8;
        transition: opacity 0.2s, visibility 0.2s;
        transition-delay: 0s;
      }

      svg {
        transform: scale(1);
        transition: transform 0.2s;
      }
    }
  }
`;
